import IconCell from './IconCell';
import classNames from 'classnames';
import DateCell from './DateCell';
import LinkCell from './LinkCell';
import DownloadCell from './DownloadCell';
import StatusCell from './StatusCell';

const GridCell = (props) => {
    const { value, format } = props;

    const classes = classNames('grid__cell-content', {
        'grid__cell-content--icon': format === 'icon',
        'grid__cell-content--date': format === 'date',
        'grid__cell-content--link': format === 'link' || format === 'download',
        'grid__cell-content--status': format === 'status',
    });

    return (
        <div className={classes}>
            {format === 'icon' ? (
                <IconCell value={value} />
            ) : format === 'date' ? (
                <DateCell value={value} />
            ) : format === 'link' ? (
                <LinkCell value={value} url={props.row.original.url} />
            ) : format === 'download' ? (
                <DownloadCell value={value} url={props.row.original.url} />
            ) : format === 'status' ? (
                <StatusCell value={value} />
            ) : (
                <>{value}</>
            )}
        </div>
    )
}

export default GridCell;